import { useEffect, useMemo } from 'react'
import { Module, OnAddSectionProps } from '../../types'

type ValidModuleHookProps = {
  modules: Module[]
  componentNames: string[]
  minModulesLength?: number
  onAddSection: (args: OnAddSectionProps) => void
}

export default function useValidModules({
  modules,
  componentNames,
  minModulesLength = 1,
  onAddSection,
}: ValidModuleHookProps): Module[] {
  const validModules = useMemo(
    () =>
      modules?.filter((m) => {
        const name = m.componentName || m.name || ''
        return componentNames.includes(name)
      }) || [],
    [modules, componentNames]
  )

  useEffect(() => {
    if (validModules?.length < minModulesLength && onAddSection)
      onAddSection({})
  }, [onAddSection, minModulesLength, validModules])

  return validModules || []
}
